import { useTranslation } from 'react-i18next';

import { Box } from './Box';
import { Loader } from './Loader';

export const FullPageLoading = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  return (
    <Box
      component="main"
      aria-busy="true"
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <Loader size="large" label={t('labels.loading')} />
    </Box>
  );
};
